import { render, staticRenderFns } from "./Sitemap-links.vue?vue&type=template&id=38c0bbd5"
import script from "./Sitemap-links.vue?vue&type=script&lang=js"
export * from "./Sitemap-links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports